import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

const PaymentCanceled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="pt-32 pb-24">
        <div className="container mx-auto px-6 max-w-lg text-center">
          <div className="bg-card border border-border/50 p-10">
            <X size={48} className="text-muted-foreground mx-auto mb-4" />
            <h1 className="font-serif text-3xl font-bold italic mb-2">Payment Canceled</h1>
            <p className="text-muted-foreground font-light mb-6">
              Your payment was not completed. Your booking is still pending — you can try again from your account.
            </p>
            <div className="flex flex-col gap-3">
              <Button
                onClick={() => navigate("/account")}
                className="rounded-none px-10 py-5 text-xs font-medium tracking-[0.3em] uppercase border border-primary hover:bg-primary/90"
              >
                View My Appointments
              </Button>
              <Button
                onClick={() => navigate("/book")}
                variant="outline"
                className="rounded-none px-10 border-primary/30 hover:bg-primary/10 tracking-[0.2em] uppercase text-xs font-medium"
              >
                Book Again
              </Button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default PaymentCanceled;
